function Notification() {
    "use strict";

    this.__type = 'Notification:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.AgentId = -1;
    this.ContactTypeId = -1;
    this.HitLevelId = -1;
    this.IsActive = true;
    this.IsImmediate = false;
    this.NotificationTypeId = -1;
    this.RiskLevelId = -1;
    this.Scope = 1;
    this.WorkingHoursType = -1;
    this.TransactionId = '';
    this.ContactFormatId = -1;
    this.UserContactId = -1;
    this.UserContactPriority = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = Notification;
}